<template>
	<div id="tabSettlement" class="page">
		<div v-if="balanceVisible" class="va-row mb-3" style="display: flex; justify-content: space-between;">
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.totalAmount' | translate}}</h5>
							<small>{{'t.processingFeeIncluded' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in totalAmount" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.netIncome' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in netIncome" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.balance' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in balance" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12" v-if="settlementAmount">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.settlementAmount' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in settlementAmount" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
			<div class="flex md2 xs12" style="position: relative;" v-if="payout">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.withdraw' | translate}}</h5>
							<small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in payout" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
					<div class="flex va-row mt-2">
						<button class="btn btn-primary btn-micro" @click="createWithdraw" style="position:absolute;left:0;">
							<b>{{'t.createWithdraw' | translate}}</b>
						</button>
					</div>
				</vuestic-widget>
			</div>
      <div class="flex md2 xs12" v-if="reserveArray">
				<vuestic-widget class="info-widget">
					<div class="info-widget-inner">
						<div class="w-title mb-2" style="min-height: 80px;">
							<h5>{{'t.reserve' | translate}}</h5>
              <small>{{'t.processingFeeDeducted' | translate}}</small>
						</div>
						<div class="w-content" v-for="(item, index) in reserveArray" :key="index">
							<span>{{ getJsonKey(item) }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getJsonValue(item) }}</span>
						</div>
					</div>
				</vuestic-widget>
			</div>
		</div>

		<tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged">
			<tab v-if="settlementAmount || !balanceVisible" name="Sales Statement">
				<div class="billed-info" v-show="salesPostData.salesView">
					<section class="flex md12 xs12">
						<div class="flex md12 xs12 p-l-20">
							<label class="select-title">CreateDate：</label>
							<date-picker v-model="sales.dates" range style="width: 240px;" :format="momentFormat"
								placeholder="Start Day  ~  End Day"></date-picker>
							<el-button type="success" class="account-statement" @click="querySalesList">{{ $t("basic.button.search") }}</el-button>
						</div>
						<div class="dataGrid-settlement">
							<el-table :data="sales.tableData" style="width: 100%"
								:default-sort="{ prop: 'create_time', order: 'descending' }">
								<el-table-column :label="$t('t.id')" width="220">
									<template slot-scope="scope">
										<span class="green-id-fetch-info" @click="saleIdCk($event, scope.row)">{{
											scope.row.id }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" :label="$t('tables.apping.createDate')" sortable></el-table-column>
								<!--  width="180" -->
								<el-table-column prop="period_date" label="REPORT PERIOD"></el-table-column>
								<!-- width="240" -->
								<el-table-column prop="total_processing_fee" label="TOTAL AMOUNT"></el-table-column>
								<!--  width="180" -->
								<el-table-column prop="payout_amount"
									label="SETTLEABLE AMOUNT"></el-table-column><!--   width="180" -->
								<el-table-column prop="payout_status"
									label="SETTLEMENT STATUS"></el-table-column><!--   width="180" -->
								<el-table-column prop="payout_date" label="SETTLEMENT DATE"></el-table-column>
								<!--  width="180" -->
								<el-table-column label="REPORTS">
									<template slot-scope="scope">
										<el-button size="small" class="down-load"
											@click="handleDownLoad(scope.$index, scope.row)">download</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="block" v-show="sales.total > sales.limit">
								<pagination :total="sales.total" layout="total, sizes, prev, pager, next, jumper" background
									:page-size="sales.limit" :page.sync="sales.pageNO" :limit.sync="sales.limit"
									:page-sizes="[10, 20, 30, 40, 50, 100]" @pagination="querySalesList" />
							</div>
						</div>
					</section>
				</div>
				<div class="billed-one-details" v-show="!salesPostData.salesView && salesPostData.saleNo">
					<h6 class="bill-detail-title p-l-baseF">
						<b>Sales Statement</b>
						<span class="m-l-baseF Light-color-character">{{ salesPostData.saleNo }}</span>
					</h6>
					<section class="bill-detail-info">
						<div class="va-row">
							<div class="flex xs12 md6">
								<label class="lb-w-l p-l-baseF">Report Period:</label>
								<span class="m-l-baseF Light-color-character">{{ salesPostData.period_date }}</span>
							</div>
							<div class="flex xs12 md6">
								<label class="lb-w-r-add20">Report Generated Date:</label>
								<span class="m-l-baseF Light-color-character">{{ salesPostData.payout_date }}</span>
							</div>
						</div>
					</section>
					<section class="statistics">
						<el-table class="report-detail" :data="saleDetails" style="width: 100%">
							<el-table-column prop="postage" label="DESCRIPTION"></el-table-column> <!--   width="320" -->
							<el-table-column prop="successMoney" :label="$t('t.success')"></el-table-column><!--   width="280" -->
							<el-table-column prop="changebackMoney"
								label="Charegeback"></el-table-column><!--  width="280" -->
							<el-table-column prop="refundMoney" :label="$t('t.refund')"></el-table-column> <!--  width="280" -->
							<el-table-column prop="total" :label="$t('t.total')"
								class-name="light-green"></el-table-column><!--   width="320" -->
						</el-table>
					</section>
					<div class="flex md12 xs12 statistics">
						<div class="va-row">
							<div class="flex md4">
								<button class="btn btn-primary btn-micro" @click="goBack('sales')">
									<div class="btn-with-icon-content">Back</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</tab>

			<tab v-if="settlementAmount || !balanceVisible" name="Settlement Reports">
				<div id="tabSettleReport" class="page report-wrap" v-show="reportsPostData.reportsView">
					<section class="flex md12 xs12">
						<div class="flex md12 xs12">
							<label class="select-title">Settlement Date：</label>
							<date-picker v-model="reports.dates" range style="width: 240px;" :format="momentFormat"
								placeholder="Start Day  ~  End Day"></date-picker>
							<el-button type="success" class="account-statement" @click="queryReportsList">{{ $t("basic.button.search") }}</el-button>
						</div>
						<div class="dataGrid-report">
							<el-table :data="reports.tableData" style="width: 100%"
								:default-sort="{ prop: 'settlement_date', order: 'ascending' }">
								<el-table-column :label="$t('t.id')"> <!--   width="400" -->
									<template slot-scope="scope">
										<span class="green-id-fetch-info" @click="reportIdCk($event, scope.row)">{{
											scope.row.id }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="sale_statement_id" label="SALES STATEMENT ID"></el-table-column>
								<!--  width="400" -->
								<el-table-column prop="settlement_date" label="SETTLEMENT DATE" sortable></el-table-column>
								<!--   width="360" -->
								<el-table-column label="REPORTS">
									<template slot-scope="scope">
										<el-button size="small" class="down-load"
											@click="handleDownLoad(scope.$index, scope.row)">download</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="block" v-show="reports.total > reports.limit">
								<pagination :total="reports.total" layout="total, sizes, prev, pager, next, jumper"
									background :page-size="reports.limit" :page.sync="reports.pageNO"
									:limit.sync="reports.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
									@pagination="queryReportsList" />
							</div>
						</div>
					</section>
				</div>
				<div class="billed-one-details" v-show="!reportsPostData.reportsView && reportsPostData.reportNO">
					<h6 class="bill-detail-title p-l-baseF">
						<b>Settlement Report</b>
						<span class="m-l-baseF Light-color-character">{{ reportsPostData.reportNO }}</span>
					</h6>
					<section class="bill-detail-info">
						<div class="va-row">
							<div class="flex xs12 md6">
								<label class="lb-w-l p-l-baseF">Report Period:</label>
								<span class="m-l-baseF Light-color-character">{{ reportsPostData.period_date }}</span>
							</div>
							<div class="flex xs12 md6">
								<label class="lb-w-r-add20">Report Generated Date:</label>
								<span class="m-l-baseF Light-color-character">{{ reportsPostData.payout_date }}</span>
							</div>
						</div>
						<div class="va-row">
							<div class="flex xs12 md6">
								<label class="lb-w-l p-l-baseF">Exchange Rate:</label>
								<span class="m-l-baseF Light-color-character">{{ reportsPostData.rate }}</span>
							</div>
							<div class="flex xs12 md6">
								<label class="lb-w-r-add20">Sales Statement ID:</label>
								<span class="m-l-baseF Light-color-character">{{ reportsPostData.sale_statement_id }}</span>
							</div>
						</div>
					</section>
					<section class="statistics">
						<report-details :table-data="currentSelectedDetail"></report-details>
					</section>
					<div class="flex md12 xs12 statistics">
						<div class="va-row">
							<div class="flex md4">
								<button class="btn btn-primary btn-micro" @click="goBack('reports')">
									<div class="btn-with-icon-content">Back</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</tab>

			<tab v-if="settlementAmount || !balanceVisible" name="Invoice">
				<div id="tabInvoice" class="page invoice-wrap">
					<section class="flex md12 xs12">
						<div class="flex md12 xs12">
							<label class="select-title">CreateDate：</label>
							<date-picker v-model="invoices.dates" range style="width: 240px;" :format="momentFormat"
								placeholder="Start Day  ~  End Day"></date-picker>
							<el-button type="success" class="account-statement" @click="queryInvoiceList">{{ $t("basic.button.search") }}</el-button>
						</div>
						<div class="dataGrid-report">
							<el-table :data="invoices.tableData" style="width: 100%"
								:default-sort="{ prop: 'settlement_date', order: 'ascending' }">
								<el-table-column :label="$t('t.id')"> <!--   width="400" -->
									<template slot-scope="scope">
										<span>{{ scope.row.id }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="settlement_id" label="SETTLEMENT ID"></el-table-column>
								<!--   width="400" -->
								<el-table-column prop="create_date" :label="$t('tables.statusHisInfo.date')" sortable></el-table-column>
								<!--   width="360" -->
								<el-table-column label="REPORTS">
									<template slot-scope="scope">
										<el-button size="small" class="down-load"
											@click="handleDownLoad(scope.$index, scope.row)">download</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="block" v-show="invoices.total > invoices.limit">
								<pagination :total="invoices.total" layout="total, sizes, prev, pager, next, jumper"
									background :page-size="invoices.limit" :page.sync="invoices.pageNO"
									:limit.sync="invoices.limit" :page-sizes="[10, 20, 30, 40, 50, 100]"
									@pagination="queryInvoiceList" />
							</div>
						</div>
					</section>
				</div>
			</tab>

			<tab v-if="payout && balanceVisible" :name="$t('t.payoutHistory')">
				<div id="tabPayoutHistory" class="page invoice-wrap">
					<section class="flex md12 xs12">
						<div class="flex md12 xs12">
							<label class="select-title">{{ "t.createDate" | translate }}：</label>
							<date-picker v-model="payoutHistory.dates" range style="width: 240px;" :format="momentFormat"
								placeholder="Start Day  ~  End Day"></date-picker>
							<el-button type="success" class="account-statement"
								@click="queryPayoutHistory">{{ $t('basic.button.search') }}</el-button>
						</div>
						<div class="dataGrid-report">
							<el-table :data="payoutHistory.tableData" tooltip-effect="light" class="dataGrid-report-table">
								<el-table-column min-width="240" prop="withdraw_id" :label="$t('t.id')"></el-table-column>
								<el-table-column min-width="150" prop="desc" :label="$t('t.remark')" show-overflow-tooltip></el-table-column>
								<el-table-column min-width="100" prop="request_currency" :label="$t('t.currency')"></el-table-column>
								<el-table-column min-width="150" prop="request_amount" :label="$t('tables.listing.amount')"></el-table-column>
								<el-table-column min-width="150" prop="create_time" :label="$t('tables.listing.recurring_create_time')"></el-table-column>
								<el-table-column prop="status" :label="$t('tables.listing.status')"></el-table-column>
							</el-table>
							<div class="block" v-show="payoutHistory.total > payoutHistory.pageSize">
								<pagination :total="payoutHistory.total" layout="total, sizes, prev, pager, next, jumper"
									background :page-size="payoutHistory.pageSize" :page.sync="payoutHistory.pageNum"
									:limit.sync="payoutHistory.pageSize" :page-sizes="[10, 50, 100]"
									@pagination="queryPayoutHistory" />
							</div>
						</div>
					</section>
				</div>
			</tab>
		</tabs>

		<vuestic-modal :show.sync="withdrawDialogVisible" ref="withdraw" :okText="'modal.confirm2' | translate"
			style="height: 100%;width:60vw;" :okClass="'btn btn-primary btn-micro'"
			:cancelClass="'btn btn-secondary btn-micro'" :cancelText="'modal.cancel2' | translate" alignModal="">
			<div slot="title">{{ $t("t.withdraw") }}</div>
			<div>
				<form>
					<div class="va-row">
						<div class="flex xs12 md12">
							<fieldset class="withdraw-modal">
								<div class="info-group">
									<div class="form-group with-icon-right"
										:class="{ 'has-error': initCurrencyVaild, 'valid': isCurrencyValid('currency') }">
										<div class="input-group">
											<vuestic-kyc-select id="currencyInput" name="currency" data-vv-as="Currency"
												v-validate="'required'" required label="Currency："
												v-model="withdrawData.currency" option-key="label" :options="currencies"
												autocomplete="off"
												@input="(val) => { currencyStatus = !val ? true : false; generateExchangeRate(); updateArrivedCurrencyOption(val) }" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa icon-right input-icon"></i>
											<small v-show="initCurrencyVaild" class="help text-danger">{{
												errors.first('currency') }}</small>
										</div>
									</div>
									<div class="info-group-space"></div>
									<div class="form-group with-icon-right withdraw-to-close">
										<div class="input-group">
											<vuestic-kyc-select name="withdrawTo" data-vv-as="Withdraw to"
												:label="`${$t('t.withdrawTo')}：`" v-model="withdrawTo" option-key="label"
												:options="withdrawToOption" autocomplete="off" @input="withdrawToChange" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa icon-right input-icon"></i>
										</div>
									</div>
								</div>

								<div class="info-group">
									<div class="form-group with-icon-right" v-if="isBank">
										<div class="input-group">
											<input name="settlementFee" data-vv-as="Settlement Fee" v-model="settlementFee"
												autocomplete="off" :disabled="true" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="settlementFee">{{ "t.settlementFee" | translate }}</label>
											<i class="bar"></i>
										</div>
									</div>
									<div class="form-group with-icon-right withdraw-to-close" v-if="!isBank">
										<!-- <div class="input-group"> -->
										<div class="form-group with-icon-right"
											:class="{ 'has-error': initPayoutAccounts, 'valid': isPayoutAccountsValid('payoutAccounts') }">
											<div class="input-group">
												<vuestic-kyc-select name="Payout Accounts" data-vv-as="Payout Accounts"
													label="Payout Accounts：" v-model="payoutAccounts"
													option-key="account_name" option-value="account_id"
													:options="payoutAccountsOptions" autocomplete="off" @input="(val) => {
														payoutAccountsStatus = !val ? true : false; payoutAccountsChange(val)
													}" />
												<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
												<i class="fa icon-right input-icon"></i>
												<small v-show="initPayoutAccounts" class="help text-danger">{{
													errors.first('payoutAccounts') }}</small>
											</div>
										</div>
										<!-- </div> -->
									</div>
									<div class="info-group-space"></div>
									<div class="form-group with-icon-right"
										:class="{ 'has-error': errors.has('amount'), 'valid': isFormFieldValid('amount') }"
										v-if="isBank">
										<div class="input-group">
											<input name="amount" data-vv-as="Amount" v-model="withdrawData.amount"
												autocomplete="off" v-validate="'required'" type="text" required
												@input="changeAmountValue" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="amount">{{ "t.amount" | translate }}</label>
											<i class="bar"></i>
											<small v-show="errors.has('amount')" class="help text-danger">{{
												errors.first('amount') }}</small>
										</div>
									</div>
									<div class="form-group with-icon-right withdraw-to-close" v-if="!isBank">
										<!-- <div class="info-group"> -->
										<div class="form-group with-icon-right"
											:class="{ 'has-error': initArrivedCurrency, 'valid': isArrivedCurrencyValid('arrivedCurrency') }">
											<div class="input-group">
												<vuestic-kyc-select name="arrivedCurrency" data-vv-as="Arrived Currency"
													label="Arrived Currency：" v-model="arrivedCurrency"
													:options="arrivedCurrencyOption" autocomplete="off"
													@input="(val) => { arrivedCurrencyStatus = !val ? true : false; arrivedCurrencyChange() }" />
												<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
												<i class="fa icon-right input-icon"></i>
												<small v-show="initArrivedCurrency" class="help text-danger">{{
													errors.first('arrivedCurrency') }}</small>
											</div>
											<!-- </div> -->
										</div>
									</div>
								</div>

								<div class="info-group" v-if="!isBank">
									<div class="form-group with-icon-right"
										:class="{ 'has-error': errors.has('amount'), 'valid': isFormFieldValid('amount') }">
										<div class="input-group">
											<!-- amountChange -->
											<input name="amount" data-vv-as="Amount" v-model="withdrawData.amount"
												autocomplete="off" v-validate="'required'" type="text" required
												@change="amountChange" @input="changeAmountValue" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="amount">{{ "t.amount" | translate }}</label>
											<i class="bar"></i>
											<small v-show="errors.has('amount')" class="help text-danger">{{
												errors.first('amount') }}</small>
										</div>
									</div>
									<div class="info-group-space"></div>
									<div class="form-group with-icon-right">
										<div class="input-group">
											<input name="arrivedAmount" data-vv-as="Arrived Amount" v-model="arrivedAmount"
												autocomplete="off" :disabled="true" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="arrivedAmount">{{ $t("finance.arrivedAmount") }}</label>
											<i class="bar"></i>
										</div>
									</div>
								</div>

								<div class="info-group" v-show="!isBank">
									<div class="form-group with-icon-right">
										<div class="input-group">
											<input name="exchangeRate" data-vv-as="exchangeRate" v-model="exchangeRate"
												autocomplete="off" :disabled="true" />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="exchangeRate">{{ $t("finance.exchangeRate") }}</label>
											<el-tooltip class="item" effect="light"
												content="According to local regulations we need to take the funds outside the territory and bring them back for local payouts, because of that the available balance in local currency needs to be converted into USD, then back to the local currency. And the FX is applied during the conversion."
												placement="right">
												<i class="el-icon-question"></i>
											</el-tooltip>
											<i class="bar"></i>
										</div>
									</div>
									<!-- <div class="info-group-space"></div>
                  <div class="form-group with-icon-right">
                  </div> -->
								</div>

								<div class="info-group">
									<div class="form-group with-icon-right"
										:class="{ 'has-error': errors.has('remark'), 'valid': isFormFieldValid('remark') }">
										<div class="input-group">
											<textarea name="remark" data-vv-as="Remark" v-model="withdrawData.remark"
												autocomplete="off" v-validate="'required'" maxlength="200" required />
											<i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
											<i class="fa fa-check valid-icon icon-right input-icon"></i>
											<label class="control-label" for="remark">{{ "t.remark" | translate }}</label>
											<i class="bar"></i>
											<small v-show="errors.has('remark')" class="help text-danger">{{
												errors.first('remark') }}</small>
										</div>
									</div>
								</div>
							</fieldset>
						</div>
					</div>
				</form>
			</div>
		</vuestic-modal>
	</div>
</template>

<script>
import Vue from "vue";
import "../../tabs/tabs-component.css";
import { Tabs, Tab } from "vue-tabs-component";
import Pagination from "../Pagination/index";
import BigNumber from "bignumber.js/bignumber.mjs";
import ReportDetails from "./reportDetails";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import qs from "qs";
import { request, formatDate2Day, getStartDateOf1Month } from "@/utils/utils";
var moment = require("moment-timezone");

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
export default {
	name: "financial-management",
	data() {
		return {
			balanceVisible: false,
			totalAmount: [],
			netIncome: [],
			balance: [],
			settlementAmount: undefined,
			payout: undefined,
			settlementFees: [],
      reserveArray: undefined,
			settlementFee: 'Not set',
			settlementFeeCurrency: '',
			settlementFeeAmount: '',
			currencies: [],
			momentFormat: "", // 默认是一个字符串
			// {
			// 	stringify: date => {
			// 		return date ? moment(date).format("YYYY-MM-DD") : "";
			// 	},
			// 	parse: value => {
			// 		return value ? moment(value, "YYYY-MM-DD").toDate() : null;
			// 	}
			// },
			currTimeZone: "America/Sao_Paulo",
			sales: {
				title: "sales",
				total: 0,
				pageNO: 1,
				limit: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
			salesPostData: {
				salesView: true,
				payout_date: "",
				period_date: "",
				saleNo: "",
				settlement_id: ""
			},
			saleDetails: [
				{
					postage: "Quantity",
					successMoney: "",
					changebackMoney: "",
					refundMoney: "",
					total: ""
				},
				{
					postage: "Payable Amount",
					successMoney: "",
					changebackMoney: "",
					refundMoney: "",
					total: ""
				},
				{
					postage: "Processing Fee",
					successMoney: "",
					changebackMoney: "",
					refundMoney: "",
					total: ""
				}
			],
			reports: {
				title: "reports",
				total: 0,
				pageNO: 1,
				limit: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
			reportsPostData: {
				reportsView: true,
				payout_date: "",
				period_date: "",
				reportNO: "",
				rate: "",
				sale_statement_id: ""
			},
			reportDetails: [],
			invoices: {
				total: 0,
				pageNO: 1,
				limit: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
			payoutHistory: {
				total: 0,
				pageNum: 1,
				pageSize: 10,
				dates: [getStartDateOf1Month(), formatDate2Day(new Date())],
				tableData: []
			},
			currentSelectedDetail: [
				{ 2: "DESCRIPTION", 16: "AMOUNT", 20: "SETTLEMENT AMOUNT" }
			],
			// withdraw 功能
			withdrawDialogVisible: true,
			withdrawData: {
				currency: '',
				amount: '',
				fee_currency: '',
				fee_amount: '',
			},
			currencyStatus: false,
			payoutAccountsStatus: false,
			arrivedCurrencyStatus: false,
			withdrawTo: { label: 'Bank', value: 'Bank' }, // Withdraw To
			withdrawToOption: [
				{ label: 'Bank', value: 'Bank' },
				{ label: 'Payout Balance', value: 'Payout Balance' }
			],
			payoutAccounts: {},
			payoutAccountsOptions: [],
			arrivedCurrency: '',
			arrivedCurrencyOption: [],
			arrivedAmount: "",
			exchangeRate: "",
			withdrawToken: "",
			otherPayoutBean: {},
			isBank: true,
			isPayout: false
		};
	},
	components: {
		Pagination,
		ReportDetails,
		DatePicker
	},
	computed: {
		isMobile: function () {
			if (document.body.clientWidth && document.body.clientWidth < 750) {
				return "mobile";
			}
			return "pc";
		},
		initCurrencyVaild: function () {
			return this.currencyStatus
		},
		initPayoutAccounts: function () {
			return this.payoutAccountsStatus
		},
		initArrivedCurrency: function () {
			return this.arrivedCurrencyStatus
		}
	},
	mounted() {
		this.init();
	},
	watch: {
		'withdrawData.currency'() {
			const fee = this.settlementFees[this.withdrawData.currency.value]
			if (fee) {
				const amount = this.settlementFees[this.withdrawData.currency.value].amount
				const currency = this.settlementFees[this.withdrawData.currency.value].currency
				this.settlementFee = `${amount} ${currency}`
				this.withdrawData.fee_amount = amount
				this.withdrawData.fee_currency = currency
			} else {
				this.settlementFee = 'Not set'
			}
		},
	},
	methods: {
		init() {
			this.querySalesList();
			this.queryRevenueList();
		},
		formatAmount(num) {
			if (num === 0) {
				return 0;
			}
			let str = new BigNumber(String(num));
			return str.toFormat(2);
		},
		getJsonKey(json) {
			for (var name in json) {
				return name;
			}
		},
		getJsonValue(json) {
			for (var name in json) {
				return json[name];
			}
		},
		dateFormat(value, formatStr = "YYYY-MM-DD HH:mm:ss") {
			return moment
				.tz(moment.tz(value, "UTC"), this.currTimeZone)
				.format(formatStr);
		},
		stringifyDate(date) {
			return date ? moment(date).format("YYYY-MM-DD") : "";
		},
		formatSalesList(listObj) {
			let listData = [];
			let trItem = {};
			for (let i = 0; i < listObj.length; i++) {
				trItem = {
					id: listObj[i].sales_statement_report_id,
					create_time: listObj[i].create_time,
					period_date: listObj[i].start_date + " ~ " + listObj[i].end_date,
					total_processing_fee: listObj[i].apply_currency + " " + this.formatAmount(listObj[i].apply_amount),
					payout_amount: listObj[i].payout_currency + " " + this.formatAmount(listObj[i].payout_amount),
					payout_status: listObj[i].payout_status === 0 ? "PROCESSING" : "SETTLED",
					payout_date: listObj[i].payout_date,
					down_url: listObj[i].sales_statement_report_url,
					settlement_id: listObj[i].settlement_id
				};
				listData.push(trItem);
			}
			return listData;
		},
		formatReportsList(listObj) {
			let listData = [];
			let trItem = {};
			for (let i = 0; i < listObj.length; i++) {
				trItem = {
					id: listObj[i].settlement_report_id,
					sale_statement_id: listObj[i].sales_statement_report_id,
					settlement_date: listObj[i].payout_date,
					period_date: this.dateFormat(listObj[i].start_date, "YYYY-MM-DD") + " ~ " + this.dateFormat(listObj[i].end_date, "YYYY-MM-DD"),
					rate: listObj[i].rate,
					down_url: listObj[i].settlement_report_url,
					settlement_id: listObj[i].settlement_id
				};
				listData.push(trItem);
			}
			return listData;
		},
		getListReports(tabObj) {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				start_date: this.dateFormat(this.stringifyDate(tabObj.dates[0]), "YYYY-MM-DD"),
				end_date: this.dateFormat(this.stringifyDate(tabObj.dates[1]), "YYYY-MM-DD"),
				page_num: tabObj.pageNO,
				page_size: tabObj.limit
			};
			request({
				method: "post",
				url: "api/dashboard/settle/list-reports",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					this.$set(tabObj, "total", data.total);
					this.$set(tabObj, "pageNO", data.page_num);
					this.$set(tabObj, "limit", data.page_size);

					if (data.list.length > 0) {
						let lists_tr = [];
						if (tabObj.title === "sales") {
							lists_tr = this.formatSalesList(data.list);
						} else if (tabObj.title === "reports") {
							lists_tr = this.formatReportsList(data.list);
						}
						this.$set(tabObj, "tableData", lists_tr);
					} else {
					}
				})
				.catch(err => { });
		},
		querySalesList() {
			this.$set(this.sales, "tableData", []);
			this.getListReports(this.sales);
		},
		queryReportsList() {
			this.$set(this.reports, "tableData", []);
			this.getListReports(this.reports);
		},
		queryRevenueList() {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization")
			}
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/detail",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					if (data.code === '10000') {
						this.balanceVisible = true
						this.totalAmount = data.data.total_amount
						this.netIncome = data.data.net_income
						this.balance = data.data.balance
						this.settlementAmount = data.data.settlement_amount
						this.payout = data.data.payout
						this.settlementFees = data.data.settlement_fee
            this.reserveArray = data.data.reserve

						this.currencies = []
						for (var item of this.balance) {
							for (var key in item) {
								const currency = {
									value: key,
									label: `${key}(${item[key]})`
								}
								this.currencies.push(currency)
							}
						}

            if (this.payout && this.balanceVisible) {
              // tabName = 'Payout History'
              this.queryPayoutHistory();
            }
            if (this.settlementAmount || !this.balanceVisible) {
              // tabName = 'Sales Statement'
              this.querySalesList();
            }
					}
				})
				.catch(err => { });
		},
		formatInvoicesList(listObj) {
			let listData = [];
			let trItem = {};
			for (let i = 0; i < listObj.length; i++) {
				trItem = {
					id: listObj[i].invoice_id,
					settlement_id: listObj[i].settlement_id,
					create_date: this.dateFormat(listObj[i].create_time),
					down_url: listObj[i].invoice_url
				};
				listData.push(trItem);
			}
			return listData;
		},
		queryInvoiceList() {
			this.$set(this.invoices, "tableData", []);
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				start_date: this.dateFormat(this.stringifyDate(this.invoices.dates[0]), "YYYY-MM-DD"),
				end_date: this.dateFormat(this.stringifyDate(this.invoices.dates[1]), "YYYY-MM-DD"),
				page_num: this.invoices.pageNO,
				page_size: this.invoices.limit
			};
			request({
				method: "post",
				url: "api/dashboard/settle/list-invoices",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					this.$set(this.invoices, "total", data.total);
					this.$set(this.invoices, "pageNO", data.page_num);
					this.$set(this.invoices, "limit", data.page_size);

					if (data.list.length > 0) {
						let lists_tr = this.formatInvoicesList(data.list);
						this.$set(this.invoices, "tableData", lists_tr);
					} else {
						return;
					}
				})
				.catch(err => { });
		},
		queryPayoutHistory() {
			this.$set(this.payoutHistory, "tableData", []);
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				start_date: this.stringifyDate(this.payoutHistory.dates[0]) + ' 00:00:00',
				end_date: this.stringifyDate(this.payoutHistory.dates[1]) + ' 23:59:59',
				page_num: this.payoutHistory.pageNum,
				page_size: this.payoutHistory.pageSize,
				currency: ''
			};
			request({
				method: "post",
				url: "api/dashboard/merchant/assets/withdraw/list",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					if (data.code !== '10000') {
						return;
					}
					this.$set(this.payoutHistory, "total", data.data.total);

					if (data.data.list.length > 0) {
						let lists_tr = data.data.list.map(v => {
							if (v.desc) {
								v.desc = JSON.parse(v.desc).remark
							}
							return v;
						})
						this.$set(this.payoutHistory, "tableData", lists_tr);
					} else {
						return;
					}
				})
				.catch(err => { });
		},
		tabChanged(selectedTab) {
			// if ("Sales Statement" === selectedTab.tab.name) {
			// 	this.querySalesList();
			// } else if ("Settlement Reports" === selectedTab.tab.name) {
			// 	this.queryReportsList();
			// } else if ("Invoice" === selectedTab.tab.name) {
			// 	this.queryInvoiceList();
			// } else if ("Payout History" === selectedTab.tab.name) {
			// 	this.queryPayoutHistory();
			// }
		},
		tabClicked(selectedTab) {
			if ("Sales Statement" === selectedTab.tab.name) {
				this.querySalesList();
			} else if ("Settlement Reports" === selectedTab.tab.name) {
				this.queryReportsList();
			} else if ("Invoice" === selectedTab.tab.name) {
				this.queryInvoiceList();
			} else if (this.$t('t.payoutHistory') === selectedTab.tab.name) {
				this.queryPayoutHistory();
			}
		},
		handleDownLoad(index, row) {
			this.downFile(row.down_url);
		},
		downFile(downUrl) {
			request({
				method: "post",
				url: "api/dashboard/settle/download",
				params: {
					access_token: localStorage.getItem("Authorization"),
					key: downUrl
				},
				headers: {
					"Content-Type": "application/json"
				},
				responseType: "blob"
			})
				.then((res) => {
					if (!res.data) {
						return false;
					} else {
						let fileName =
							res.headers["content-disposition"].split("=")[1] || downUrl;
						let blob = new Blob([res.data]);
						if ("download" in document.createElement("a")) {
							let link = document.createElement("a");
							link.href = window.URL.createObjectURL(blob); // 创建下载的链接
							link.download = fileName; // 下载后文件名
							link.style.display = "none";
							document.body.appendChild(link);
							link.click(); // 点击下载
							window.URL.revokeObjectURL(link.href); // 释放掉blob对象
							document.body.removeChild(link); // 下载完成移除元素
						} else {
							// IE10+下载
							window.navigator.msSaveBlob(blob, fileName);
						}
					}
				})
				.catch(err => { });
		},
		fetchSaleDetail() {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				settlement_id: this.salesPostData.settlement_id
			};
			request({
				method: "post",
				url: "api/dashboard/settle/sales-statement-report/detail",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					if (Object.keys(data).length >= 2) {
						this.$set(this.saleDetails, 0, {
							postage: "Quantity",
							successMoney: data.success.quantity,
							changebackMoney: data.chargeback.quantity,
							refundMoney: data.refund.quantity,
							total: data.total.quantity
						});
						this.$set(this.saleDetails, 1, {
							postage: "Payable Amount",
							successMoney: `${data.success.pay_amount.currency} ${this.formatAmount(data.success.pay_amount.amount)}`,
							changebackMoney: `${data.chargeback.pay_amount.currency} ${this.formatAmount(data.chargeback.pay_amount.amount)}`,
							refundMoney: `${data.refund.pay_amount.currency} ${this.formatAmount(data.refund.pay_amount.amount)}`,
							total: `${data.total.pay_amount.currency} ${this.formatAmount(data.total.pay_amount.amount)}`
						});
						this.$set(this.saleDetails, 2, {
							postage: "Processing Fee",
							successMoney: `${data.success.processing_fee.currency} ${this.formatAmount(data.success.processing_fee.amount)}`,
							changebackMoney: `${data.chargeback.processing_fee.currency} ${this.formatAmount(data.chargeback.processing_fee.amount)}`,
							refundMoney: `${data.refund.processing_fee.currency} ${this.formatAmount(data.refund.processing_fee.amount)}`,
							total: `${data.total.processing_fee.currency} ${this.formatAmount(data.total.processing_fee.amount)}`
						});
						if (data.tax.name) {
							this.$set(this.saleDetails, 3, {
								postage: data.tax.name,
								total: `${data.tax.source_amount.currency} ${this.formatAmount(data.tax.source_amount.amount)}`
							});
						}
						this.$set(this.saleDetails, 4, {
							postage: "SETTLEABLE AMOUNT",
							total: `${data.settleable.source_amount.currency} ${this.formatAmount(data.settleable.source_amount.amount)}`
						});
					} else {
						return;
					}
				})
				.catch(err => { });
		},
		saleIdCk(e, row) {
			this.saleDetails.splice(0, this.saleDetails.length);
			this.$set(this.salesPostData, "saleNo", e.target.innerHTML);
			this.$set(this.salesPostData, "payout_date", row.payout_date);
			this.$set(this.salesPostData, "period_date", row.period_date);
			this.$set(this.salesPostData, "settlement_id", row.settlement_id);
			this.fetchSaleDetail();
			this.$set(this.salesPostData, "salesView", false);
		},
		filterReportDetailsByName(data) {
			var reportD_Fields = ['total', 'chargeback', 'chargeback_covered', 'refund', 'tax', 'processing_fee', 'settleable', 'chargeback_fee', 'refund_fee', 'avs_fee', 'settlement', 'settlement_fee', 'adjustment', 'payout'];
			var reportD_FieldsNO = [2, 3, 3, 3, 3, 3, 2, 3, 3, 3, 2, 3, 3, 2];
			for (let i = 1; i <= reportD_Fields.length; i++) {
				if (data[reportD_Fields[i]].name) {
					this.$set(this.currentSelectedDetail, i, {
						[reportD_FieldsNO[i]]: data[reportD_Fields[i]].name,
						16: (data[reportD_Fields[i]].source_amount.amount < 0 ? '-' : '') + `${data[reportD_Fields[i]].source_amount.currency}${this.formatAmount(Math.abs(data[reportD_Fields[i]].source_amount.amount))}`,
						20: (data[reportD_Fields[i]].target_amount.amount < 0 ? '-' : '') + `${data[reportD_Fields[i]].target_amount.currency}${this.formatAmount(Math.abs(data[reportD_Fields[i]].target_amount.amount))}`
					});
				} else {
					this.$set(this.currentSelectedDetail, i, '');
				}
			}
		},
		fetchReportDetail() {
			let queryParameters = {
				access_token: localStorage.getItem("Authorization"),
				settlement_id: this.reportsPostData.settlement_id
			};
			request({
				method: "post",
				url: "api/dashboard/settle/settlement-report/detail",
				params: queryParameters,
				headers: {
					"Content-Type": "application/json"
				}
			})
				.then(res => {
					let data = res.data;
					this.$set(this.reportsPostData, "rate", data.total.rate);
					if (Object.keys(data).length >= 2) {
						this.filterReportDetailsByName(data)
					} else {
						return;
					}
				})
				.catch(err => { });
		},
		reportIdCk(e, row) {
			this.reportDetails.splice(0, this.reportDetails.length);
			this.currentSelectedDetail.splice(
				1,
				this.currentSelectedDetail.length - 1
			);
			this.$set(this.reportsPostData, "reportNO", e.target.innerHTML);
			this.$set(this.reportsPostData, "payout_date", row.settlement_date);
			this.$set(this.reportsPostData, "period_date", row.period_date);
			this.$set(this.reportsPostData, "settlement_id", row.settlement_id);
			this.$set(this.reportsPostData, "rate", "");
			this.$set(
				this.reportsPostData,
				"sale_statement_id",
				row.sale_statement_id
			);
			this.fetchReportDetail();
			this.$set(this.reportsPostData, "reportsView", false);
		},
		goBack(wayName) {
			if ("sales" === wayName) {
				this.$set(this.salesPostData, "salesView", true);
			} else if ("reports" === wayName) {
				this.$set(this.reportsPostData, "reportsView", true);
			}
		},
		// withdraw 功能
		createWithdraw() {
			// 获取数据
			this.fetchPayoutAccounts()
			this.isBank = true
			this.withdrawDialogVisible = true;
			this.$refs.withdraw.open()
			this.$validator.reset()
			this.withdrawData = {
				currency: '',
				amount: '',
				fee_currency: '',
				fee_amount: '',
				remark: ''
			}
			this.withdrawTo = { label: 'Bank', value: 'Bank' }
			this.settlementFee = 'Not set';
			this.arrivedCurrencyOption = []
			this.arrivedCurrency = ''
			let that = this
			that.$refs.withdraw.ok = () => {
				if (!that.withdrawData.currency.value) {
					that.$message({ type: "error", message: 'Currency can not be empty' });
					return;
				}
				if (that.withdrawData.amount === '' || that.withdrawData.amount <= 0) {
					that.$message({ type: "error", message: 'Amount can not be empty' });
					return;
				}
				if (that.withdrawData.remark && that.withdrawData.remark.length > 200) {
					that.$message({ type: "error", message: 'The remark length cannot be greater than 200' });
					return;
				}

				// for (var variable of that.balance) {
				// 	console.log(that.balance);
				// 	for (var item in variable) {
				// 		console.log(item);
				// 		console.log(that.withdrawData);
				// 		// 这里有问题，variable是个数组，variable[item]并不能直接取到对应币种的金额
				// 		if (item === that.withdrawData.currency.value && that.withdrawData.amount > variable[item]) {
				// 			that.$message({type: "error", message: 'Insufficient Balance' });
				// 			return;
				// 		}
				// 	}
				// }
				if (that.withdrawTo.value === 'Payout Balance') {
					if (!that.payoutAccounts || !that.payoutAccounts.id) {
						that.$message({ type: "error", message: 'Payout Accounts can not be empty' });
						return;
					}
					if (!that.arrivedCurrency) {
						that.$message({ type: "error", message: 'Arrived Currency can not be empty' });
						return;
					}
				}

				that.$validator.validateAll().then((result) => {
					if (that.checkWithdrawData() && result) {
						that.withdrawDialogVisible = false
						const access_token = localStorage.getItem("Authorization")
						let params = {
							amount: that.withdrawData.amount,
							currency: that.withdrawData.currency.value,
							fee_amount: that.withdrawData.fee_amount,
							fee_currency: that.withdrawData.fee_currency,
							remark: that.withdrawData.remark,
						}
						if (that.isPayout) {
							params.payout = that.isPayout
							params.account_id = that.payoutAccounts.account_id
							params.withdraw_token = that.withdrawToken
							params.arrival_currency = that.otherPayoutBean.target_currency
							params.arrival_amount = that.otherPayoutBean.target_amount
							params.exchange_rate = that.otherPayoutBean.exchange_rate
						}
						this.loadingFullScreen('exchangeRateLoading', 'loading', 'fa fa-hourglass-half')
						request({
							method: "post",
							url: `api/dashboard/merchant/assets/withdraw?access_token=${access_token}`,
							data: params,
							headers: {
								"Content-Type": "application/json"
							}
						})
							.then(res => {
								that.exchangeRateLoading.close()
								let data = res.data;
								if (data.code === "10000") {
									that.$message({
										type: "success",
										duration: 5000,
										message: data.msg
									});
									this.$refs.withdraw.close()
									that.queryRevenueList();
								} else {
									that.$message({
										type: "error",
										duration: 5000,
										message: data.msg
									});
								}
							})
							.catch(err => { });
					}
				})
			}
		},
		isCurrencyValid(field) {
			let isValid = false
			if (this.currencyStatus) {
				isValid = true
			}
			return isValid
		},
		isPayoutAccountsValid(field) {
			let isValid = false
			if (this.payoutAccountsStatus) {
				isValid = true
			}
			return isValid
		},
		isArrivedCurrencyValid(field) {
			let isValid = false
			if (this.arrivedCurrencyStatus) {
				isValid = true
			}
			return isValid
		},
		isFormFieldValid(field) {
			let isValid = false
			if (this.formFields[field]) {
				isValid =
					this.formFields[field].validated && this.formFields[field].valid
			}
			return isValid
		},
		checkWithdrawData() {
			let that = this
			let withdrawArray = ['currency']
			let isValidate = withdrawArray.reduce((result, current) => {
				if (!that.withdrawData[current]) {
					that[current + 'Status'] = true
				} else {
					that[current + 'Status'] = false
				}
				return result && !that[current + 'Status']
			}, true)
			return isValidate
		},
		withdrawToChange(item) {
			if (item.value === 'Payout Balance') {
				this.isBank = false
				this.isPayout = true
				this.payoutAccounts = {}
				this.arrivedCurrency = ''
				this.arrivedAmount = ""
				this.exchangeRate = ""
			} else {
				this.isBank = true
				this.isPayout = false
				// this.withdrawData.remark = ""
			}
		},
		fetchPayoutAccounts() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			request({
				method: "post",
				url: `api/dashboard/merchant/assets/payout-accounts?access_token=${access_token}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				let data = res.data;
				that.payoutAccountsOptions = data.data
				// that.$message({
				// 	type: "success",
				// 	duration: 5000,
				// 	message: data.msg
				// });
			})
				.catch(err => { });
		},
		payoutAccountsChange(item) {
			if (item) {
        this.payoutAccounts = item
        if (this.withdrawData.currency && item.supported_currencies_map[this.withdrawData.currency.value]) {
          this.arrivedCurrencyOption = item.supported_currencies_map[this.withdrawData.currency.value]
        } else {
          this.arrivedCurrencyOption = []
        }
        this.arrivedCurrency = ''
			} else {
				this.payoutAccounts = {}
				this.arrivedCurrencyOption = []
				this.arrivedCurrency = ''
				this.arrivedAmount = ""
				this.exchangeRate = ""
			}
		},
    updateArrivedCurrencyOption(currency) {
      if (this.payoutAccounts && currency) {
        if (this.payoutAccounts.supported_currencies_map && this.payoutAccounts.supported_currencies_map[currency.value]) {
          this.arrivedCurrencyOption = this.payoutAccounts.supported_currencies_map[currency.value]
        } else {
          this.arrivedCurrencyOption = []
        }
      }
      this.arrivedCurrency = ''
    },
		generateExchangeRate() {
			if (this.withdrawData.currency && this.arrivedCurrency && this.withdrawData.amount) {
				// 获取商户Withdraw汇率
				this.fetchExchangeRate()
			} else {
				this.withdrawToken = ""
				this.arrivedAmount = ""
				this.exchangeRate = ""
				this.otherPayoutBean = {}
			}
		},
		fetchExchangeRate() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			this.loadingFullScreen('exchangeRateLoading', 'loading', 'fa fa-hourglass-half')
			request({
				method: "post",
				url: `api/dashboard/merchant/assets/withdraw/exchange-rate?access_token=${access_token}&source=${that.withdrawData.currency.value}&target=${that.arrivedCurrency}&amount=${that.withdrawData.amount}&payout_id=${that.payoutAccounts.id}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				that.exchangeRateLoading.close()
				if (res.data.code === "10000") {
					let data = res.data.data;
					that.withdrawToken = data.withdraw_token
					that.arrivedAmount = data.target_amount
					that.exchangeRate = data.exchange_rate
					that.otherPayoutBean = data
				} else {
					that.withdrawToken = ''
					that.arrivedAmount = 'Not set'
					that.exchangeRate = 'Not set'
					that.otherPayoutBean = {}
				}
			})
				.catch(err => { });
		},
		amountChange(item) {
			this.generateExchangeRate()
		},
		changeAmountValue() {
			this.withdrawData.amount = this.withdrawData.amount.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')
		},
		arrivedCurrencyChange(item) {
			this.generateExchangeRate()
		},
		loadingFullScreen(controller, txt, className) {
			this[controller] = this.$loading({
				lock: true,
				text: txt,
				spinner: className,
				background: 'rgba(0, 0, 0, 0.7)',
			})
		}
	}
};
</script>
<style>
.el-tooltip {
	color: #4ae387;
	position: absolute;
	top: -10px;
	left: 95px;
}

.el-table--enable-row-hover .el-table__body tr:hover>td:not(.light-green) {
	background-color: transparent;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.light-green {
	background-color: rgba(26, 188, 156, 0.19);
}

.el-tooltip__popper {
	max-width: 400px;
}
</style>
<style lang="scss" scoped>
*,
*:after,
*:before {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

/deep/ .tabs-component-tabs {
	padding: 0;
}

/deep/ .tabs-component-tab-a {
	font-size: 16px;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.647);
}

/deep/ .tabs-component-tab.is-active {
	.tabs-component-tab-a {
		color: $VUE_APP_COLOR4;
	}
}

.page {
	background-color: #fff;
	border-radius: 3px;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.025);
	margin: 0 auto;
	padding: 10px 20px;
}

.p-l-20 {
	padding-left: 16px;
}

.head-area {
	margin-bottom: 10px;
}

.billed-info {
	position: relative;
}

.billed-amount,
.amount-not-billed,
.closing-cycle {
	list-style-type: none;
}

.billed-amount,
.amount-not-billed {
	width: 400px;
	height: 100px;
	display: inline-block;
	text-align: center;

	.bill-title {
		font-size: 14px;
		font-weight: 400;
		line-height: 32px;
		overflow-wrap: break-word;
		text-rendering: optimizelegibility;
		color: rgba(0, 0, 0, 0.447);
	}

	.amount-of-money {
		font-size: 18px;
		font-weight: 400;
		line-height: 32px;
		text-rendering: optimizelegibility;
		color: rgba(0, 0, 0, 0.847);
	}
}

.closing-cycle {
	position: absolute;
	top: 0;
	right: 120px;
	text-align: left;

	.settlement-cycle {
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
		text-rendering: optimizelegibility;
		white-space: nowrap;
	}

	.settlement-date {
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
		text-rendering: optimizelegibility;
		white-space: nowrap;
		color: rgba(0, 0, 0, 0.647);
	}
}

.account-statement {
	width: 78px;
	height: 34px;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
	color: rgb(255, 255, 255);
	text-align: center;
	line-height: 34px;
	border-width: 0px;
	border-radius: 4px;
	white-space: nowrap;
	background-color: $VUE_APP_COLOR4;
	margin-left: 20px;
}

.billed-info {
	background-color: #eee;
}

section {
	background-color: #ffffff;
	padding: 20px 0 10px;
}

.down-load {
	padding: 5px 8px;
	color: #1890ff;
}

.dataGrid-settlement {
	padding: 10px 16px 0;
}

.block {
	text-align: right;
}

/deep/ .pagination-container {
	padding: 32px 16px 10px;
}

.green-id-fetch-info {
	color: $VUE_APP_COLOR4;
	width: max-content;
	cursor: pointer;
}

.bill-detail-title {
	height: 54px;
	line-height: 36px;
}

.p-l-baseF {
	padding-left: 16px;
}

.m-l-baseF {
	margin-left: 16px;
}

.Light-color-character {
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
	color: rgba(102, 102, 102, 0.75);
	text-align: left;
	line-height: 22px;
}

h6 {
	border-bottom: 1px solid rgb(233, 233, 233);
}

.lb-w-l {
	width: 120px;
}

.lb-w-r {
	width: 160px;
}

.lb-w-r-add20 {
	width: 180px;
}

.statistics {
	padding: 10px 10px;
}

/deep/ .light-green {
	background-color: rgba(26, 188, 156, 0.19);
}

/deep/ .el-table thead {
	color: #000;
	font-weight: 700;
}

/deep/ .report-detail .el-table__body tbody tr:last-of-type td {
	background-color: rgba(26, 188, 156, 0.19);

	&:first-of-type {
		color: #000;
		font-weight: 700;
	}
}

.dataGrid-report {
	padding: 10px 0 0;
  /deep/ .dataGrid-report-table {
    .el-tooltip {
      position: unset;
    }
  }
}



.lb-w-l-add60 {
	width: 190px;
}

@media (min-width: 700px) {
	.page {
		padding: 10px 20px;
		margin-bottom: 30px;
	}

	/deep/ .tabs-component-tab {
		-webkit-transform: translateY(0px);
		transform: translateY(0px);
	}

	/deep/ .tabs-component-panels {
		padding: 0;
	}

	.report-wrap {
		padding: 0 20px;
		margin-bottom: 0;
	}

	.invoice-wrap {
		padding: 0 20px;
		margin-bottom: 0;
	}
}

.prefix,
.suffix {
	align-items: center;
	border-radius: 1.25rem;
	display: flex;
	font-size: 0.75rem;
	flex-shrink: 0;
	height: 1.25rem;
	justify-content: center;
	line-height: 1.25rem;
	min-width: 1.25rem;
	padding: 0 0.1em;
}

.prefix {
	background-color: #d1e8eb;
	color: #0c5174;
	margin-right: 0.35em;
}

.suffix {
	background-color: #c03;
	color: #fff;
	margin-left: 0.35em;
}

@media (min-width: 700px) {
	.suffix {
		position: absolute;
		right: -0.725em;
		top: -0.725em;
	}
}

@media (max-width: 750px) {
	/deep/ .tabs-component-tab {
		width: 33.33%;
		display: inline-block;

		&:nth-child(2) {
			border-left: 1px solid rgb(221, 221, 221);
			border-right: 1px solid rgb(221, 221, 221);
		}
	}

	.account-statement {
		margin-left: 10px;
	}

	.date-picker {
		width: 200px !important;
	}

	.closing-cycle {
		position: absolute;
		top: -50px;
		right: 10px;
	}

	.billed-amount,
	.amount-not-billed {
		margin: 20px 0;
	}

	.select-title {
		display: block;
		margin-bottom: 10px;
	}

	/deep/ .tabs-component-panels {
		padding: 4em 0 1em;
	}

	.page {
		padding: 10px;
		margin-bottom: 50px;
	}

	/deep/ .mx-datepicker-range {
		width: 200px !important;
	}
}

@media (max-width: 320px) {
	.page {
		padding: 2px;
		margin-bottom: 50px;
	}

	.account-statement {
		width: 58px;
	}
}

.tableTitle {
	position: relative;
	margin: 0 auto;
	width: 100%;
	height: 4px;
	background-color: #4ae387;
	text-align: center;
	font-size: 16px;
	color: rgba(101, 101, 101, 1);
}

.info-group {
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-bottom: 2rem;

	.info-group-space {
		width: 4rem;
	}
}

.withdraw-modal {
	.info-group {
		/deep/ .form-group {
			width: 100%;
		}

		/deep/ .select-form-group {
			margin-bottom: 0;
		}

		/deep/ .withdraw-to-close {
			.vuestic-simple-select__unselect {
				display: none;
			}
		}
	}
}

/deep/ #currencyInput .scrollbar-wrapper {
	max-height: 200px !important;
	// overflow-y: scroll;
}

input[disabled="disabled"]~label.control-label {
	font-size: 0.6rem;
	color: #4ae387;
	font-weight: 600;
	text-transform: uppercase;
	top: -0.6rem;
	left: 0;
}
</style>
